module.exports = __webpack_public_path__ + "media/images/marker-c57dadf47997c5ba7cab9e4322977e3d.png";